import axios from 'axios'

const appInstances = {
  /**
   * Returns the app instances object
   *
   * @returns {Promise<Object>}
   */
  getAppInstances({ offset, limit } = {}) {
    return axios.get('/api/account-management/appInstances', {
      params: {
        authorization: 'TRUSTED',
        ...(offset && { offset }),
        ...(limit && { limit })
      }
    })
  },

  /**
   * Deletes app instance by consumer id provided by JWT or Cookie(appInstanceId)
   *
   * @param {String} id
   * @returns {Promise<Object>}
   */
  deleteAppInstance(id) {
    return axios.delete(`/api/account-management/appInstances/${id}`)
  }
}

export default appInstances
